"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { TrendingUp, Users, Award, Target } from "lucide-react";
import { useState } from "react";
export default function MeasurableOutcomes() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const [imageHovered, setImageHovered] = useState(false);
  const metrics = [{
    icon: TrendingUp,
    label: "Student Progress",
    value: "92% improvement in IEP goal achievement"
  }, {
    icon: Users,
    label: "Engagement Rate",
    value: "87% increase in student participation"
  }, {
    icon: Award,
    label: "Parent Satisfaction",
    value: "95% positive feedback from families"
  }, {
    icon: Target,
    label: "Retention",
    value: "98% student retention year-over-year"
  }];
  return <section ref={sectionRef} className="relative min-h-screen w-full bg-dark-background py-16 md:py-20">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div className="space-y-6">
            <h2 className={`font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-dark mb-8 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
              Measurable Outcomes
            </h2>

            <div className="space-y-4">
              {metrics.map((metric, i) => {
              const Icon = metric.icon;
              return <div key={i} data-index={i} className={`flex items-start gap-4 p-6 rounded-lg bg-dark-background/40 border border-border/20 hover:border-accent/40 hover:bg-dark-background/60 transition-all duration-[var(--duration-medium)] ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
                animationDelay: isVisible ? `${i * 100}ms` : "0ms"
              }}>
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-accent/20 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-accent" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-display text-lg font-semibold text-foreground-dark mb-1">
                        {metric.label}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {metric.value}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </div>

          {}
          <div className={`relative rounded-xl overflow-hidden shadow-strong ${isVisible ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
            <div className="relative overflow-hidden" onMouseEnter={() => setImageHovered(true)} onMouseLeave={() => setImageHovered(false)}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1465435/img/special_education_student_success.png" alt="Student engaged in virtual special education session" className="w-full h-auto object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
              transform: imageHovered ? "scale(1.02)" : "scale(1)"
            }} />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-background/80 via-dark-background/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-foreground-dark text-sm md:text-base font-medium">
                  Technology-enhanced learning environments empower students
                  with diverse needs to achieve their full potential through
                  personalized, AI-driven instruction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}